import { NarratorNPC } from '../../../../src/feature/narrator/narrator.model';
import { dialog } from './dialog';

export const reeveBeggen: NarratorNPC = {
  id: 'reeve-beggen',
  name: 'Reeve',
  dialog: dialog,
};
